
export enum ProfessionalBookingCriteria { 
    inD_NO_MEMBERSHIP = 0,
    inD_WITH_MEMBERSHIP = 1,
    inD_WITH_MEMBERSHIP_B2B_OPTED = 2,
    orG_MEMBER = 3
}

